import React from 'react';
import * as styles from './styles.scss';

const SmallQuantityButtons = ({
    handleDelete = () => {},
    handleRemove,
    handleAdd,
    quantity,
    isLoading,
    maxSaleQuantity,
}) => (
    <div className={styles.group}>
        <button
            className={styles.left}
            onClick={quantity === 1 ? handleDelete : handleRemove}
            disabled={isLoading}
            aria-label="Remove"
        />
        <span className={styles.quantity}>
            {quantity}
        </span>
        <button
            className={styles.right}
            onClick={handleAdd}
            disabled={isLoading || maxSaleQuantity === quantity}
            aria-label="Add"
        />
    </div>
);

export default SmallQuantityButtons;
